var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToggleclose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 0C6.4858 0 0 6.48518 0 14.5C0 22.5143 6.48518 29 14.5 29C22.5142 29 29 22.5148 29 14.5C29 6.48575 22.5148 0 14.5 0ZM14.5 26.7344C7.73802 26.7344 2.26562 21.2625 2.26562 14.5C2.26562 7.73796 7.73751 2.26562 14.5 2.26562C21.262 2.26562 26.7344 7.73751 26.7344 14.5C26.7344 21.262 21.2625 26.7344 14.5 26.7344Z",
    fill: "#121826"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4609 17.8589L16.102 14.5L19.4609 11.1411C19.9033 10.6987 19.9033 9.98149 19.461 9.53907C19.0185 9.09665 18.3013 9.09671 17.859 9.53907L14.5 12.898L11.141 9.53907C10.6987 9.09665 9.98138 9.09665 9.53902 9.53907C9.09665 9.98149 9.09665 10.6987 9.53907 11.1411L12.898 14.5L9.53907 17.8589C9.09665 18.3013 9.0966 19.0186 9.53902 19.4609C9.98155 19.9034 10.6988 19.9032 11.141 19.4609L14.5 16.102L17.859 19.4609C18.3012 19.9033 19.0186 19.9033 19.461 19.4609C19.9034 19.0185 19.9033 18.3013 19.4609 17.8589Z",
    fill: "#121826"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleclose);
export default __webpack_public_path__ + "static/media/toggleclose.9dde79f4fea4876d763662119701ad17.svg";
export { ForwardRef as ReactComponent };